import { Component, h, State } from '@stencil/core';

@Component({
  tag: 'legrandav-sampleform',
  styleUrl: 'legrandav-sampleform.css',
  shadow: true,
})
export class LegrandavSampleform {
  @State() value: string;
  @State() selectValue: string;
  @State() secondSelectValue: string;
  @State() emailEntered: string;
  @State() dropdownSelectedValue: string;

  handleSubmit(e) {
    e.preventDefault();
    window.alert(`${this.emailEntered} selected  ${this.dropdownSelectedValue}`);
  }

  handleSelect(e) {
    this.dropdownSelectedValue = e.target.value;
  }

  handleEmailSelect(e) {
    this.emailEntered = e.target.value;
  }

  render() {
    return (
      <div class="legrandav-sampleform-wrapper">
        <form onSubmit={e => this.handleSubmit(e)}>
          <label>Email:</label>
          <input id="email" type="email" value={this.value} onInput={event => this.handleEmailSelect(event)} />
          <label>Products:</label>
          <select onInput={event => this.handleSelect(event)}>
            <option value="LTM1U" selected={this.selectValue === 'LTM1U'}>
              LTM1U
            </option>
            <option value="BGR-1927" selected={this.selectValue === 'BGR1927'}>
              BGR-1927
            </option>
            <option value="XTM1U" selected={this.selectValue === 'XTM1U'}>
              XTM1U
            </option>
          </select>

          <input type="submit" value="Submit" />
        </form>
      </div>
    );
  }
}
